import { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { UserContext } from "../../../../Context/UserContext";
import { debounce } from "lodash";
import { BaseURL } from "../../../../Reusable/BaseURL";
import ClipLoader from "react-spinners/ClipLoader";
import AsyncSelect from "react-select/async";
import { CustomConfirmDialog } from "../../../../Reusable/CustomConfirmDialog";
import { confirmAlert } from "react-confirm-alert";

export const IndentPOPartySelect = ({
  selectedOption,
  setSelectedOption,
  unsavedIndentItem,
  setUnsavedIndentItem,
  changingSelect,
  setChangingSelect,
  getUnsavedItemList,
  myCachePartyId,
  setBrand,
  setItem,
  setUnit,
  setQty,
  setInitialLoading,
}) => {
  const { darkTheme, loginData, setIndentPOCache } = useContext(UserContext);

  const [options, setOptions] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=> {
    fetchCacheParty()
  },[myCachePartyId])


  // GET INDENT PO CACHE DATA 
  const setIndentCache = async (selec) => {
    // setInitialLoading(true)
    setIsLoading(true);
    const ids = selec && selec.map((item, index) => item.value);
    const selectedPartyId = [...ids];
    const removeIndent = selectedPartyId.filter((item) => item !== selec.value);
    // console.log("removeIndent", selectedPartyId, removeIndent)

    const formData = {
      indent_ids: selectedPartyId,
    };
    const response = await fetch(`${BaseURL}/purchase/po/setcacheindents`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    if(data.status){
      await getUnsavedItemList();
    }
    const indents = data?.data?.items || [];
    await setIndentPOCache(indents);
    // await setUnsavedIndentItem(indents)
    if (data.status === true || data.status === false) {
      setIsLoading(false);
      // setInitialLoading(false)
    }else{
      setIsLoading(false);
      // setInitialLoading(false)
    }
  };

  // cache party set when page refresh
  async function fetchCacheParty() {
    try {
      if (myCachePartyId !== "") {
        setIsLoading(true);
        const response = await fetch(
          `${BaseURL}/purchase/po/getparties?q=`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${loginData.token}`,
            },
          }
        );
        const data = await response.json();
        const myFilter = data.data.data.filter(
          (item) => item.id === myCachePartyId
        );
        const transformedOptions = myFilter.map((item) => ({
          value: item.id,
          label: item.name,
          gst_no: item.gst_no,
          grade: item.grade,
        }));
        const myFind = transformedOptions.find(
          (item) => item.value === myCachePartyId
        );
        if (myFind) {
          setSelectedOption(myFind);
        }
        if (data.status === true || data.status === false) {
          setIsLoading(false);
        }
      }
      // initialIndentDivisionData();
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  }

  // Fetch initial data on component mount
  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     try {
  //       if (selectedOption !== "") {
  //         setIsLoading(true);
  //         const response = await fetch(
  //           `${BaseURL}/purchase/po/getparties?q=${selectedOption}`,
  //           {
  //             method: "GET",
  //             headers: {
  //               Accept: "application/json",
  //               Authorization: `Bearer ${loginData.token}`,
  //             },
  //           }
  //         );
  //         const data = await response.json();
  //         const myFilter = data.data.data.filter(
  //           (item) => item.name === selectedOption
  //         );
  //         const transformedOptions = myFilter.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }));
  //         const myFind = transformedOptions.find(
  //           (item) => item.label === selectedOption
  //         );
  //         setSelectedOption(myFind);
  //         if (data.status === true || data.status === false) {
  //           setIsLoading(false);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching initial data:", error);
  //     }
  //   };
  //   fetchInitialData();
  // }, [changingSelect]);

  // Function to fetch data based on input
  // const fetchData = useCallback(
  //   debounce(async (input) => {
  //     setIsLoading(true);
  //     const API_URL = `${BaseURL}/purchase/po/getparties?q=${input}`;
  //     const response = await fetch(API_URL, {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${loginData.token}`,
  //       },
  //     });
  //     const data = await response.json();
  //     const transformedOptions = data.data.data.map((item) => ({
  //       value: item.id,
  //       label: item.name,
  //       gst_no: item.gst_no,
  //       grade: item.grade,
  //     }));
  //     setOptions(transformedOptions);
  //     if (data.status === true || data.status === false) {
  //       setIsLoading(false);
  //     }
  //   }, 300),
  //   []
  // );

  // useEffect(() => {
  //   fetchData(inputValue);
  // }, []);

  // Function to load options based on user input
  const loadOptions = (inputValue, callback) => {
    fetch(`${BaseURL}/purchase/po/getpartiesforindent?q=${inputValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const options = data.data.data.map((item) => ({
          value: item.id,
          label: `${item.name} ${item.grade ? `(L-${item.grade})` : ""}`,
          gst_no: item.gst_no,
          grade: item.grade,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        callback([]);
      });
  };
  const debouncedLoadOptions = debounce(loadOptions, 400);

  // const fetchInitialData = async () => {
  //   // if (selectedOption !== "") {
  //   setIsLoading(true);
  //   const response = await fetch(
  //     `${BaseURL}/purchase/po/getparties?q=${selectedOption}`,
  //     {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${loginData.token}`,
  //       },
  //     }
  //   );
  //   const data = await response.json();
  //   const myFilter = data.data.data.filter(
  //     (item) => item.name === selectedOption
  //   );
  //   const transformedOptions = myFilter.map((item) => ({
  //     value: item.id,
  //     label: item.name,
  //     gst_no: item.gst_no,
  //     grade: item.grade,
  //   }));
  //   const myFind = transformedOptions.find(
  //     (item) => item.label === selectedOption
  //   );
  //   if (myFind) {
  //     setSelectedOption(myFind);
  //   }
  //   if (data.status === true || data.status === false) {
  //     setIsLoading(false);
  //   }
  //   // }else{

  //   // }
  // };

  // SET CACHE for Party
  async function postCacheItem(partyId) {
    const selectedData = {
      party_id: partyId,
    };
    const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
    // console.log("divisiiiiData", data);
    // console.log("selectDivsion", selectedData);
  }

  // const handleFocus = () => {
  //   fetchData(inputValue);
  // };

  // Handle input change
  // const handleInputChange = (newValue) => {
  //   setInputValue(newValue);
  //   fetchData(newValue);
  // };


  // CHANGE PARTY CONFIRMATION
  function checkDivsionChange(myChoice) {
    // if(unsavedIndentItem.length > 0){
    showDialog(myChoice);
    // }
  }
  const showDialog = (myChoice) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomConfirmDialog
            title="Are you sure?:Change-Party!"
            message="Your Added items will be Removed."
            onConfirm={() => {
              const changeConfirm = async () => {
                // setUnsavedIndentItem([]);
                setSelectedOption(myChoice);
                // console.log("mychoice-warning", myChoice);

                if (myChoice.label) {

                  await postCacheItem(myChoice.value);
                  // await getUnsavedItemList();
                  await setIndentCache([]);
                  // console.log("insidddd-change", myChoice);
                }
                setBrand("");
                setItem("");
                setUnit(0);
                setQty(0);
              };
              changeConfirm();
              onClose();
            }}
            onCancel={onClose}
          />
        );
      },
      closeOnClickOutside: false,
    });
  };
  // close check party change

  // Handle option select
  const handleChange = (selectedOption) => {
    // setSelectedOption(selectedOption);
    // if (selectedOption) {
    //   postCacheItem(selectedOption.value);
    // };

    if (unsavedIndentItem.length > 0) {
      checkDivsionChange(selectedOption);
      // console.log("handlediv-1", option);
    } else {
      setSelectedOption(selectedOption);
      if (selectedOption?.label) {
        postCacheItem(selectedOption.value);
        // console.log("handlediv-2", option);
      }
    }
  };

  // Custom styling
  const customStyles = {
    // loading style
    // menuList: (provided) => ({
    //   ...provided,
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   minHeight: "50px",
    //   flexDirection: "column",
    //   textTransform: "uppercase",
    //   // height: "100%",
    // }),
    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "white" : "black"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const MenuList = (props) => {
    const { isLoading, children } = props;
    return (
      <components.MenuList {...props}>
        {isLoading ? (
          <div
            style={
              {
                // display: "flex",
                // flexDirection: "row",
                // justifyContent: "center",
                // alignItems: "center",
                // height: "100%",
              }
            }
          >
            <ClipLoader color="#000" loading={isLoading} size={30} />
          </div>
        ) : (
          children
        )}
      </components.MenuList>
    );
  };

  return (
    <AsyncSelect
      // onFocus={handleFocus}
      styles={customStyles}
      // options={options}
      // onInputChange={handleInputChange}
      // inputValue={inputValue}
      cacheOptions
      loadOptions={debouncedLoadOptions}
      defaultOptions

      onChange={handleChange}
      value={selectedOption}
      placeholder="Select"
      isLoading={isLoading}
      // components={{
      //   MenuList: (props) => <MenuList {...props} isLoading={isLoading} />,
      // }}
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
      // isMulti
    />
  );
};
